import { UserListItem } from '@repo/types';
import { makeRequest } from './base';

export const getUserList = (query: string): Promise<UserListItem[]> => {
  return makeRequest('get', `api/core/user-list-share/?user_contains=${query}`);
};
